// Just add your classes inside this tex tags

export const vivrestyles = `
    <style>
        
    </style>
`

